import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import HomeIconFilled from '@material-ui/icons/Home';
import ChatIconFilled from '@material-ui/icons/ChatBubble';
import { Button } from 'react-bootstrap';
import ContactsIcon from '@mui/icons-material/Contacts';
import MoreIcon from '@material-ui/icons/MoreHorizOutlined';
import ClassIcon from '@mui/icons-material/Class';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import PeopleIcon from '@mui/icons-material/People';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AddToDriveIcon from '@mui/icons-material/AddToDrive';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import LocalLibrary from '@mui/icons-material/LocalLibrary';
import { getCurrentDashboardData, getNavbarData } from '../../../redux/reducers/dashboard.reducer';
import {
  getRoleArray,
  getClientId,
  getClientUserId,
  getAppLanguage,
  getLanguageObject,
} from '../../../redux/reducers/clientUserId.reducer';

import './BottomNavigation.scss';
import ReOrderTabs from './ReOrderTabs';
import { get, isIosApp } from '../../../Utilities';
import { studyBinActions } from '../../../redux/actions/studybin.actions';
import {
  AutoAwesome,
  Campaign,
  Chat,
  EmojiEmotions,
  ImportContactsOutlined,
  ListAltOutlined,
  People,
  PersonOutlineOutlined,
  StarBorder,
} from '@mui/icons-material';
import { getGlobalMessageCount } from '../../../redux/reducers/conversations.reducer';

const BottomNavigation = (props) => {
  const {
    history,
    roleArray,
    activeNav,
    dashboardData,
    clientId,
    clientUserId,
    navbarData,
    setFolderIdArrayToStore,
    languageObject,
    globalMessageCount,
    appLanguage,
  } = props;
  const [scrolledUp, setScrolledUp] = useState(false);
  const [filteredFeatures, setFilteredFeatures] = useState([]);
  const [active, setActive] = useState(activeNav);
  const [reorderClicked, setReorderClicked] = useState(false);
  const draggerRef = useRef(null);
  const roleId = roleArray.includes(1)
    ? 1
    : roleArray.includes(2)
    ? 2
    : roleArray.includes(3)
    ? 3
    : 4;

  // Update active state when activeNav prop changes
  useEffect(() => {
    setActive(activeNav);
  }, [activeNav]);

  useEffect(() => {
    const { feature, featureOrder } = dashboardData;
    const uniqueFeatures = new Set();

    const filtered = featureOrder
      ?.map((ele) => {
        if (Object.keys(feature).includes(ele) && !uniqueFeatures.has(ele)) {
          uniqueFeatures.add(ele);
          feature[ele].keyName = ele;
          return feature[ele];
        }
      })
      .filter(Boolean);

    setFilteredFeatures(filtered);
  }, [dashboardData]);

  useEffect(() => {
    if (scrolledUp) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [scrolledUp]);

  const gotoAnywhere = (route, flag = false, state = null) => {
    route = '/' + route;
    if (flag) {
      setScrolledUp(false);
      setActive(activeNav);
    }
    if (!state) {
      history.push(route);
    } else {
      history.push({
        pathname: route,
        state: state,
      });
    }
  };

  const goToHome = () => {
    setActive('home');
    history.push('/');
  };

  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleClicked = () => {
    history.push('/reorder-tabs');
  };

  const moreClicked = () => {
    setScrolledUp((prev) => !prev);
    if (!scrolledUp) {
      setActive('more');
    } else {
      setActive(activeNav);
    }
  };

  const backDropClicked = () => {
    setActive(activeNav);
    setScrolledUp(false);
  };

  // Map route names to active nav keys for consistency
  const getActiveNavKey = (routeName) => {
    const routeMapping = {
      chats: 'chats',
      chats_community: 'chats_community',
      campaign: 'campaign',
      attendance: 'attendance',
      analysis: 'analysis',
      liveClasses: 'liveClasses',
      displayPage: 'displayPage',
      studyBin: 'studyBin',
      crm: 'crm',
      noticeBoard: 'noticeBoard',
      homeworkCreator: 'homeworkCreator',
      myCourses: 'myCourses',
      offlineAssignment: 'offlineAssignment',
      fees: 'fees',
      studentfees: 'fees',
      courses: 'courses',
      studentcourses: 'courses',
      mycourses: 'mycourses',
      admission: 'admission',
    };
    return routeMapping[routeName] || routeName;
  };

  const handleRoute = (name) => {
    // Set active state based on the route
    const activeKey = getActiveNavKey(name);
    setActive(activeKey);

    if (name == 'chats') {
      history.push('/conversations');
    } else if (name == 'chats_community') {
      history.push({
        pathname: '/conversations',
        state: { communityConversationId: 40773 },
      });
    } else if (name === 'campaign') {
      history.push('/campaign-dashboard');
    } else if (name == 'attendance') {
      history.push('/attendance');
    } else if (name == 'analysis') {
      history.push('/analysis/teacher');
    } else if (name == 'liveClasses') {
      history.push('/liveclasses');
    } else if (name == 'displayPage') {
      history.push('/displaypage');
    } else if (name == 'studyBin') {
      setFolderIdArrayToStore([]);
      history.push('/studybin');
    } else if (name == 'crm') {
      history.push('/crm');
    } else if (name == 'chats') {
      history.push('/converstaions');
    } else if (name == 'noticeBoard') {
      history.push('/noticeboard');
    } else if (name == 'homeworkCreator') {
      history.push(screen.width < 786 ? '/v2/notavailable' : '/v2/homeworkcreator');
    } else if (name == 'myCourses') {
      history.push('/courses/teachercourse');
    } else if (name == 'offlineAssignment') {
      history.push('/offlineassignments');
    } else if (name == 'liveClasses') {
      history.push('/liveclasses');
    } else if (name == 'forms') {
      history.push('/forms');
    } else if (name == 'referral_and_reward') {
      history.push('/credits-analytics');
    } else if (name == 'fees') {
      history.push('/teacherfees');
    } else if (name == 'studentfees') {
      history.push('/fees');
    } else if (name == 'courses') {
      history.push({ pathname: '/courses/teachercourse', state: { type: 'allCourses' } });
    } else if (name == 'studentcourses') {
      history.push({ pathname: '/allcourses', state: { type: 'allCourses' } });
    } else if (name == 'mycourses') {
      history.push({ pathname: '/courses', state: { type: 'mycourses' } });
    } else if (name == 'admission') {
      history.push({ pathname: '/admissions', state: { type: 'allCourses' } });
    } else if (name == 'practice') {
      history.push({ pathname: '/practice' });
    } else if (name == 'gopro') {
      history.push({ pathname: '/go-pro' });
    } else if (name == 'tests') {
      history.push({ pathname: '/v2/test' });
    } else if (name === 'profile') {
      history.push('/mulyankan-profile');
    } else if (name === 'booking') {
      history.push('/all-appointments');
    } else if (name === 'all_courses') {
      history.push({ pathname: '/allCourses', search: '?category=English' });
    }
  };

  return roleArray.includes(4) || roleArray.includes(5) ? (
    <>
      {scrolledUp ? <div onClick={backDropClicked} className='backDrop' /> : null}

      <div className={`bottomScrollBar${scrolledUp ? ' scrolledUp' : ''}`}>
        <div>{reorderClicked && <ReOrderTabs />}</div>
        <div className='horizontalLineContainer'>
          <div
            ref={draggerRef}
            onTouchEnd={backDropClicked}
            onClick={backDropClicked}
            className='horizontalLine'
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {/* <Button type='submit' variant='boldText' className='px-3 mt-4' onClick={handleClicked}>
            Reorder
          </Button> */}
        </div>
        <div className='squaresC'>
          {filteredFeatures?.map((ele) => {
            if (ele.keyName === 'share') return null;
            if (ele.keyName.includes('dynamicCard')) return null;
            // if (ele.keyName === 'chats') return null;
            // if (ele.keyName === 'courses') return null;
            if (ele.keyName === 'studyBin') return null;
            return (
              <div
                onClick={() => handleRoute(ele.keyName)}
                key={ele.keyName}
                className={`square${ele.keyName === active ? ' activeSquare' : ''}`}
              >
                <img src={ele.feature_icon} className='BNImage' />
                <p className='textFeatureNameBN'>
                  {ele.client_feature_name.startsWith('<')
                    ? 'Homework Creator'
                    : ele.client_feature_name_object?.[`${appLanguage}`] ||
                      ele.client_feature_name_object?.[`1`]}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <div
        className='bottomNavigation'
        style={isIosApp ? { alignItems: 'flex-start', height: '92px' } : {}}
      >
        <div
          onClick={goToHome}
          className={`bottomNavItems ${active === 'home' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
        >
          {active === 'home' ? <HomeIconFilled /> : <HomeIcon />}
          <p className='bottomNavSmallText'>{languageObject.home || 'Home'}</p>
        </div>

        {navbarData?.slice(0, 3).map((item, index) => {
          const isActive = active === getActiveNavKey(item.feature_name);
          if (item.status === 'deleted') return null;
          return (
            <div
              key={index}
              className={`bottomNavItems ${isActive ? ' activeNav' : ''} ${
                isIosApp ? 'iosNav' : ''
              }`}
              onClick={() => handleRoute(item.feature_name)}
            >
              {item.feature_name == 'chats' ? <ChatIconFilled /> : null}
              {item.feature_name == 'fees' ? <CurrencyRupeeIcon /> : null}
              {item.feature_name == 'liveClasses' ? <VideoCameraFrontIcon /> : null}
              {item.feature_name == 'videos' ? <VideoCameraFrontIcon /> : null}
              {item.feature_name == 'starPerformers' ? <MilitaryTechIcon /> : null}
              {item.feature_name == 'analysis' ? <AssignmentIndOutlinedIcon /> : null}
              {item.feature_name == 'onlineAssignment' ? <AssignmentIndOutlinedIcon /> : null}
              {item.feature_name == 'courses' ? <SchoolOutlinedIcon /> : null}
              {item.feature_name == 'homeworkCreator' ? <SchoolOutlinedIcon /> : null}
              {item.feature_name == 'studyBin' ? <AddToDriveIcon /> : null}
              {item.feature_name == 'forms' ? <ListAltOutlined /> : null}
              {item.feature_name == 'attendance' ? <PeopleIcon /> : null}
              {item.feature_name == 'noticeBoard' ? <NoteAltIcon /> : null}
              {item.feature_name == 'crm' ? <AutoAwesome /> : null}
              {item.feature_name == 'displayPage' ? <PeopleIcon /> : null}
              {item.feature_name == 'practice' ? <PeopleIcon /> : null}
              {item.feature_name == 'tests' ? <PeopleIcon /> : null}
              {item.feature_name == 'campaign' ? <Campaign /> : null}
              {item.feature_name == 'referral_and_reward' ? <EmojiEmotions /> : null}
              <p className='bottomNavSmallText'>
                {capitalizeFirstLetter(
                  (
                    item.client_feature_name_object?.[`${appLanguage}`] ||
                    item.client_feature_name_object?.[`1`]
                  )?.split(' ')?.[0],
                )}
              </p>
            </div>
          );
        })}

        <div
          onClick={moreClicked}
          className={`bottomNavItems ${active === 'more' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
        >
          <MoreIcon />
          <p className='bottomNavSmallText'>More</p>
        </div>
      </div>
    </>
  ) : roleArray.includes(1) ? (
    <div
      className='bottomNavigation'
      style={isIosApp ? { alignItems: 'flex-start', height: '92px' } : {}}
    >
       

      <div
        onClick={goToHome}
        className={`bottomNavItems ${active === 'home' ? ' activeNav' : ''} ${
          isIosApp ? 'iosNav' : ''
        }`}
      >
        {active === 'home' ? <HomeIconFilled /> : <HomeIcon />}
        <p className='bottomNavSmallText'>{languageObject.home || 'Home'}</p>
      </div>

      {navbarData?.find((ele) => ele.feature_name === 'practice')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'practice' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('practice')}
        >
          <ImportContactsOutlined />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'practice')
              ?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'practice')
                ?.feature_english_display_name}
          </p>
        </div>
      )}

      {navbarData?.find((ele) => ele.feature_name === 'tests')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'tests' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('tests')}
        >
          <AssignmentIndOutlinedIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'tests')?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'tests')?.feature_english_display_name}
          </p>
        </div>
      )}

      {clientId === 2050 && (
        <>
          {' '}
          <div
            className={`bottomNavItems position-relative ${
              active === 'chats' ? ' activeNav' : ''
            } ${isIosApp ? 'iosNav' : ''}`}
            onClick={() => handleRoute('chats')}
          >
            <Chat />
            <p className='bottomNavSmallText'>Chats</p>
            {globalMessageCount > 0 && (
              <div className='dotOnChatBottomNav' style={{ bottom: isIosApp ? '147px' : '115px' }}>
                {globalMessageCount}
              </div>
            )}
          </div>{' '}
          <div
            className={`bottomNavItems position-relative ${
              active === 'chats_community' ? ' activeNav' : ''
            } ${isIosApp ? 'iosNav' : ''}`}
            onClick={() => handleRoute('chats_community')}
          >
            <People />
            <p className='bottomNavSmallText'>Community</p>
          </div>
        </>
      )}

      {navbarData?.find((ele) => ele.feature_name === 'myCourses')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'mycourses' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('mycourses')}
        >
          <LocalLibrary />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'myCourses')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'myCourses')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      )}
      {navbarData?.find((ele) => ele.feature_name === 'courses')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'courses' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('studentcourses')}
        >
          <ClassIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'courses')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'courses')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      )}
      {navbarData?.find((ele) => ele.feature_name === 'gopro')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'gopro' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('gopro')}
        >
          <StarBorder />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'gopro')?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'gopro')?.feature_english_display_name}
          </p>
        </div>
      )}

      {navbarData?.find((ele) => ele.feature_name === 'profile')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'profile' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('profile')}
        >
          <PersonOutlineOutlined />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'profile')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'profile')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      )}
      {navbarData?.find((ele) => ele.feature_name === 'studyBin')?.status === 'active' ? (
        <div
          className={`bottomNavItems ${active === 'studyBin' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('studyBin')}
        >
          <AddToDriveIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'studyBin')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'studyBin')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      ) : navbarData?.find((ele) => ele.feature_name === 'fees')?.status === 'active' ? (
        <div
          className={`bottomNavItems ${active === 'fees' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('studentfees')}
        >
          <CurrencyRupeeIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'fees')?.client_feature_name_object?.[
              `${appLanguage}`
            ] ||
              navbarData?.find((ele) => ele.feature_name === 'fees')?.client_feature_name_object?.[
                `1`
              ]}
          </p>
        </div>
      ) : null}

      {clientId == 1104 && <div
        onClick={() => {
          if(typeof window.MobileApp !== 'undefined' && typeof window.MobileApp.onHomePressed !== 'undefined') {
            window.MobileApp.onHomePressed();
          }
        }}
        className={`bottomNavItems ${active === 'homee' ? ' activeNav' : ''} ${
          isIosApp ? 'iosNav' : ''
        }`}
      >
        <img  style={{width: '40px', borderRadius: '100px', border: '0.5px solid var(--primary-blue)'}} src='https://play-lh.googleusercontent.com/KmfOEgazCfm1PKYPn_MEP9SLNooACeiZehGT131-pL2qd0JcauqWg4GUMhwHcvu1Rp61PtuLM6TUtVOPHfscZw=w480-h960-rw' />
        {/* <p className='bottomNavSmallText'>{languageObject.home || 'Back'}</p> */}
      </div>}
    </div>
  ) : (roleArray.includes(3) || roleArray.includes(6)) && clientId === 2002 ? (
    <div
      className='bottomNavigation'
      style={isIosApp ? { alignItems: 'flex-start', height: '92px' } : {}}
    >
      <div
        onClick={goToHome}
        className={`bottomNavItems ${active === 'home' ? ' activeNav' : ''} ${
          isIosApp ? 'iosNav' : ''
        }`}
      >
        {active === 'home' ? <HomeIconFilled /> : <HomeIcon />}
        <p className='bottomNavSmallText'>{languageObject.home || 'Home'}</p>
      </div>

      {navbarData?.find((ele) => ele.feature_name === 'tests')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'tests' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('tests')}
        >
          <AssignmentIndOutlinedIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'tests')?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'tests')?.feature_english_display_name}
          </p>
        </div>
      )}

      {navbarData?.find((ele) => ele.feature_name === 'gopro')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'gopro' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('gopro')}
        >
          <StarBorder />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'gopro')?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'gopro')?.feature_english_display_name}
          </p>
        </div>
      )}
      {navbarData?.find((ele) => ele.feature_name === 'profile')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'profile' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('profile')}
        >
          <PersonOutlineOutlined />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'profile')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'profile')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      )}
       {navbarData?.find((ele) => ele.feature_name === 'forms')?.status === 'active' && (
        <div
          className={`bottomNavItems ${active === 'forms' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('forms')}
        >
          <ListAltOutlined />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'forms')
              ?.client_feature_name_object?.[`${appLanguage}`] ||
              navbarData?.find((ele) => ele.feature_name === 'forms')
                ?.client_feature_name_object?.[`1`]}
          </p>
        </div>
      )}
      {navbarData?.find((ele) => ele.feature_name === 'studyBin')?.status === 'active' ? (
        <div
          className={`bottomNavItems ${active === 'studyBin' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('studyBin')}
        >
          <AddToDriveIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'studyBin')
              ?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'studyBin')
                ?.feature_english_display_name}
          </p>
        </div>
      ) : navbarData?.find((ele) => ele.feature_name === 'myCourses')?.status === 'active' ? (
        <div
          className={`bottomNavItems ${active === 'courses' ? ' activeNav' : ''} ${
            isIosApp ? 'iosNav' : ''
          }`}
          onClick={() => handleRoute('mycourses')}
        >
          <AddToDriveIcon />
          <p className='bottomNavSmallText'>
            {navbarData?.find((ele) => ele.feature_name === 'courses')
              ?.client_feature_english_name ||
              navbarData?.find((ele) => ele.feature_name === 'courses')
                ?.feature_english_display_name}
          </p>
        </div>
      ) : null}
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    dashboardData: getCurrentDashboardData(state),
    roleArray: getRoleArray(state),
    clientId: getClientId(state),
    clientUserId: getClientUserId(state),
    navbarData: getNavbarData(state),
    appLanguage: getAppLanguage(state),
    languageObject: getLanguageObject(state),
    globalMessageCount: getGlobalMessageCount(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setFolderIdArrayToStore: (payload) => {
    dispatch(studyBinActions.setFolderIDArrayToStore(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BottomNavigation);
